import { useState } from 'react';

import { gql, useQuery } from '@apollo/client';
import { ITasksFilter } from '../../pages/tasks-manager/task-manager.interfaces';

export const GET_PROCESS_TASKS_FOR_TABLE = gql`
  query getProcessTasks($payload: GetProcessTasksInput!) {
    getProcessTasks(payload: $payload) {
      collection {
        _id
        title
        details
        createdBy
        overdue
        assignTo
        responsiblePersons {
          profile {
            displayName
          }
        }
        assignedByMember {
          profile {
            displayName
          }
        }
        dueTo
        status
        type
        process {
          _id
          title
        }
        jobId
        companyId
        departmentId
        company {
          name
        }
        job {
          title
        }
        department {
          name
        }
      }
      totalCount
    }
  }
`;

export const useGetProcessTasksForTable = (filter: ITasksFilter = {}) => {
  const { overdue, ...rest } = filter;

  const [currentPage, setPage] = useState(1);
  const pageSize = 12;
  const { data, loading } = useQuery(GET_PROCESS_TASKS_FOR_TABLE, {
    variables: {
      payload: {
        filter: { ...rest, ...(overdue?.length && { overdue: !!overdue }) },
        queryOptions: { limit: pageSize, skip: pageSize * currentPage - pageSize },
      },
    },
    fetchPolicy: 'no-cache',
  });

  const { totalCount = 0, collection = [] } = data?.getProcessTasks || {};

  return {
    loading,
    processTasks: collection,
    paginationConfig: {
      total: totalCount,
      pageSize,
      current: currentPage,
      onChange: (page: number) => setPage(page),
    },
  };
};
